import { Controller } from '@hotwired/stimulus';

interface RememberEvent extends Event {
  params: { locale: string };
}

// Liens de langue du pied de page : retient le choix pour les pages sans préfixe de
// locale (connexion, inscription, mentions), que Rack::Locale résout par ce cookie.
export default class extends Controller {
  // eslint-disable-next-line class-methods-use-this
  remember({ params }: RememberEvent): void {
    document.cookie = `locale=${params.locale}; path=/; samesite=lax`;
  }
}
